define("calendar/components/calendar/settings/stories", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.canInstagramStories}}
    <hr class="u--m__b__0" />
    <div class="u--row">
      <div class="u--col__4 u--m__t__md">
        <h5 class="u--text--md u--m__0" data-test-id="calendar-settings-instagram-stories">
          {{t "calendar.settings.stories_title"}}
        </h5>
      </div>
      <div class="u--col__8 u--m__t__md">
        <Shared::Ui::CheckboxSwitch
          @labelText={{t "calendar.settings.stories_detail"}}
          @propertyToggled={{this.showInstagramStoriesOnCalendar}}
          @toggleAction={{this.toggleInstagramStories}}
          class="u--p__0 u--m__b"
        />
      </div>
    </div>
  {{/if}}
  */
  {
    "id": "MHUUN8zs",
    "block": "[[[41,[30,0,[\"canInstagramStories\"]],[[[1,\"  \"],[10,\"hr\"],[14,0,\"u--m__b__0\"],[12],[13],[1,\"\\n  \"],[10,0],[14,0,\"u--row\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"u--col__4 u--m__t__md\"],[12],[1,\"\\n      \"],[10,\"h5\"],[14,0,\"u--text--md u--m__0\"],[14,\"data-test-id\",\"calendar-settings-instagram-stories\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"calendar.settings.stories_title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"u--col__8 u--m__t__md\"],[12],[1,\"\\n      \"],[8,[39,2],[[24,0,\"u--p__0 u--m__b\"]],[[\"@labelText\",\"@propertyToggled\",\"@toggleAction\"],[[28,[37,1],[\"calendar.settings.stories_detail\"],null],[30,0,[\"showInstagramStoriesOnCalendar\"]],[30,0,[\"toggleInstagramStories\"]]]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[],false,[\"if\",\"t\",\"shared/ui/checkbox-switch\"]]",
    "moduleName": "calendar/components/calendar/settings/stories.hbs",
    "isStrictMode": false
  });
  let StoriesComponent = _exports.default = (_class = class StoriesComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "cache", _descriptor2, this);
      _initializerDefineProperty(this, "showInstagramStoriesOnCalendar", _descriptor3, this);
      _defineProperty(this, "showInstagramStoriesOnCalendarCacheKey", 'showInstagramStoriesOnCalendar');
      const showCalendarNotesCachedValue = this.cache.retrieve(this.showInstagramStoriesOnCalendarCacheKey);
      if (typeof showCalendarNotesCachedValue === 'boolean') {
        this.showInstagramStoriesOnCalendar = showCalendarNotesCachedValue;
      }
    }
    get canInstagramStories() {
      return Boolean(this.auth.currentAccount?.canInstagramStories) && Boolean(this.auth.currentAccount?.rolloutInstagramStoriesPostBuilder);
    }
    toggleInstagramStories() {
      this.showInstagramStoriesOnCalendar = !this.showInstagramStoriesOnCalendar;
      this.cache.add(this.showInstagramStoriesOnCalendarCacheKey, this.showInstagramStoriesOnCalendar, {
        expiry: this.cache.maxExpiryDate(),
        persist: true
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "showInstagramStoriesOnCalendar", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "toggleInstagramStories", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleInstagramStories"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, StoriesComponent);
});